export default __webpack_public_path__ + "static/media/Bengali_dm_1.c363c130.mp3";